import {
    Box,
    Button,
    Card,
    CardContent,
    Grid,
    Tooltip,
} from '@mui/material';
import { ExtendedFile, ICardUpload } from './ICardUpload';
import { useEffect, useRef, useState } from 'react';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import CustomisedCardMultiUpload from './cardMultiUpload';
import CustomisedCardMultiLoad from './cardMultiLoade';
import { IDocumentResponse } from '../../models/identity.model';
import { IUploadFile } from '../uploader/IUploadFile';
import { Swiper, SwiperRef, SwiperSlide, SwiperSlideProps } from 'swiper/react';
import { EffectCards, EffectCoverflow, Navigation, Pagination } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/pagination';
import { useMutation } from 'react-query';
import { ApiResultModel, IDocument } from '../../models/common.model';
import { deleteFile } from '../../services/guarantor.service';
import './card.css';


export default function CustomisedCardMultiImage({
    title,
    comment,
    setFileSelected,
    fileExtensions,
    serviceRequestObj,
    serviceName,
    serviceNameAdd,
    serviceNameDel,
    documentArray,
    setDelImage,
    serviceRequestObjAdd,
    serviceRequestObjDel,
    setAddMultiImage,
    rejected,
    setArrayImg,
    setFileUrlDel,
    setJobArrayImg,
    setJobFileUrlDel,
    checkBySetad,
    maxSizeKb,
}: ICardUpload) {
    const [addImage, setAddImage] = useState(false);
    const [addSuccess, setAddSuccess] = useState();
    const [fileArray, setFileArray] = useState<any[]>([]);
    const [file, setFile] = useState<IUploadFile>();
    const scrollToEnd = useRef<SwiperRef>(null);

    function addDocument() {
        if (serviceRequestObjAdd !== null && serviceRequestObjAdd !== undefined) {
            serviceRequestObjAdd.file = file?.file;
            AddDocumentMutate(serviceRequestObjAdd);
        }
    }
    let delEmpty: any[] = [];

    const { mutate: AddDocumentMutate } = useMutation(serviceNameAdd, {
        onSuccess: (data: ApiResultModel<IDocument>) => {
            if (data.isSuccess) {
                if (data.data) {
                    setAddMultiImage(true);

                    delEmpty = fileArray?.filter((item: any) =>
                        item.fileUrl !== undefined
                    );
                    if (delEmpty !== undefined) {
                        setFileArray([...delEmpty!, data.data]);
                        setArrayImg([...delEmpty, data.data]);
                    } else {
                        let empty: any[] = [];
                        empty.push(data.data);
                        setFileArray(empty);
                        setArrayImg(empty);
                    }
                    setAddImage(false);
                }
            } else {
                delEmpty = fileArray?.filter((item: any) =>
                    item.fileId !== undefined
                );
                setFileArray(delEmpty);
            }
        },
    });

    const clickAddImage = () => {
        const newImage = {} as IUploadFile;
        setFileArray([...fileArray, newImage])
        setAddImage(true);
    }
    useEffect(() => {
        if (scrollToEnd.current) {
            scrollToEnd.current.swiper.slideTo(fileArray?.length + 1);
        }
    }, [fileArray])

    useEffect(() => {
        setFileArray(documentArray!);
    }, [documentArray])
    useEffect(() => {
        setAddImage(false);
    }, [addSuccess])
    useEffect(() => {
        let delEmpty = fileArray?.filter((item: any) =>
            item.fileUrl !== undefined
        )
        if (file !== undefined && delEmpty?.length > 0) {
            setFileArray([...delEmpty, file]);
            addDocument();
        }
        else if (file !== undefined && fileArray?.length > 0) {
            setFileArray([...fileArray, file]);
            addDocument();
        } else if (file !== undefined) {
            setFileArray([file]);
            addDocument();
        }

    }, [file]);


    useEffect(() => {
        if (scrollToEnd.current) {
            // scrollToEnd.current.scrollIntoView();
            // scrollToEnd.current.swiper.slideTo(index);
        }
    }, [addImage]);

    function test() {
        if (scrollToEnd.current) {
            scrollToEnd.current.swiper.slideTo(10);
        }
    }

    return (
        <Grid container xs={12} style={{ width: '70vh', flexWrap: 'nowrap' }}  >
            <Grid item xs={10} style={{ display: 'contents' }} >
                <Grid container xs={12}
                    className={`${rejected === true ? 'rejectCardBorderDesign' : rejected === false ? 'acceptCardBorderDesign' : 'cardBorderDesign'} !shadow-none`}
                    style={{
                        height: 'calc(60vh - 290px)',
                        minHeight: '180px',
                        width: ' 29rem',
                        minWidth: '20vw',
                        maxWidth: '500px',
                        background: '#fff',
                        maxHeight: '223px',
                    }}>
                    <Swiper
                        ref={scrollToEnd}
                        initialSlide={1}
                        slidesPerView={1.3}
                        spaceBetween={20}
                        scrollbar={false}
                        navigation={false}
                        style={{
                            width: '100%',
                        }}
                        loop={false}
                        centeredSlides={true}
                        speed={300}
                        modules={[Pagination]}
                        pagination={{
                            type: 'bullets',
                            clickable: true,
                            bulletClass: 'swiper-pagination-bullet',
                            bulletActiveClass: 'swiper-pagination-bullet-active',

                        }}

                    >
                        {fileArray?.length > 0 ? fileArray.map((fileArray) => (
                            <SwiperSlide >
                                <Grid item xs={12} >
                                    {fileArray?.fileUrl !== null && fileArray?.fileUrl !== undefined ?
                                        <CustomisedCardMultiLoad title={title}
                                            fileSelected={
                                                fileArray.fileUrl
                                            }
                                            fileArray={fileArray}
                                            serviceName={serviceNameDel}
                                            serviceRequestObj={serviceRequestObjDel}
                                            setDelImage={
                                                setDelImage
                                            }
                                            rejected={rejected}
                                            setFileUrlDel={setFileUrlDel}
                                            checkBySetad={checkBySetad}
                                            fileType={fileArray?.file?.fileType}
                                        />
                                        :
                                        <CustomisedCardMultiUpload title={'تصویر'} setAddSuccess={setAddSuccess} setFileSelected={setFile} fileExtensions={fileExtensions} maxSizeKb={maxSizeKb} />
                                    }

                                </Grid>
                            </SwiperSlide>
                        )) :
                            <SwiperSlide >
                                <Grid item xs={12} >
                                    <CustomisedCardMultiUpload title={'تصویر'} setAddSuccess={setAddSuccess} setFileSelected={setFile} fileExtensions={fileExtensions} maxSizeKb={maxSizeKb} />
                                </Grid>
                            </SwiperSlide>
                        }

                    </Swiper>
                </Grid>
            </Grid>
            <Grid item xs={0.3} >
            </Grid>
            <Grid item xs={2}
                style={{
                    border: 'dashed 2px #D7DBEC',
                    maxWidth: '8vh',
                    borderRadius: '5px',
                    alignContent: 'center',
                    background: '#fff'
                }}
            >

                <div className='addImage'>
                    <Button
                        disabled={(fileArray?.length > 0 || fileArray !== null) && addImage === false ? false : true}
                        style={{
                            width: '100%',
                            height: '100%', padding: '0px', minWidth: 'unset'
                        }}
                        className={`${fileArray?.length > 0 && addImage === false ? 'buttonUpladImage ' : 'buttonUpladImageDisable'}`}
                        onClick={clickAddImage}
                    >

                        <p style={{
                            whiteSpace: 'nowrap',
                            transform: 'rotate(-90deg)'
                        }}>
                            <AddCircleOutlineIcon style={{ marginLeft: '8px' }} />
                            مستند جدید
                        </p>
                    </Button>
                </div>
            </Grid>
        </Grid >

    );
}
